/** */
import React from 'react';
import { SectionCard } from 'app/shared/section-card';
import { TrendBadge } from 'app/shared/trend-badge';
import { fmt } from 'utilities/format';
import styles from './stat-card.module.css';

export const StatCard = ({ title, metric = {}, format, invert = false }) => (
  <SectionCard title={title}>
    <div className={styles.body}>
      <div className={styles.row}>
        <span className={styles.value}>{fmt(metric.value, format)}</span>
        <TrendBadge trend={metric.trend} invert={invert} />
      </div>
    </div>
  </SectionCard>
);
